/* eslint-disable @typescript-eslint/camelcase */
import homeConfig from './home.config';
import searchCharactersConfig from './search-characters.config';
import searchWorksConfig from './search-works.config';
import searchRecordsConfig from './search-records.config';
import searchEditionsConfig from './search-editions.config';
import searchSamplesConfig from './search-samples.config';
import searchNewsConfig from './search-news.config';
import resourceWorkConfig from './resource-work.config';
import resourceRecordConfig from './resource-record.config';
import resourceEditionConfig from './resource-edition.config';
import resourceSampleConfig from './resource-sample.config';
import advancedSearchConfig from './advanced-search.config';
import advancedResultsConfig from './advanced-results.config';
import resourceCharacterConfig from './resource-character.config';
import resourcePlaceConfig from './resource-place.config';
import pageConfig from './page.config';
import postConfig from './post.config';
import searchPlacesConfig from './search-places.config';
import resourceMotifConfig from './resource-motif.config';
import searchMotifsConfig from './search-motifs.config';

export default {
  home: homeConfig,
  'search-works': searchWorksConfig,
  'search-characters': searchCharactersConfig,
  'search-records': searchRecordsConfig,
  'search-editions': searchEditionsConfig,
  'search-samples': searchSamplesConfig,
  'search-places': searchPlacesConfig,
  'search-news': searchNewsConfig,
  'advanced-search': advancedSearchConfig,
  'advanced-results': advancedResultsConfig,
  'resource-work': resourceWorkConfig,
  'resource-record': resourceRecordConfig,
  'resource-edition': resourceEditionConfig,
  'resource-sample': resourceSampleConfig,
  'resource-character': resourceCharacterConfig,
  'resource-place': resourcePlaceConfig,
  'resource-motif': resourceMotifConfig,
  page: pageConfig,
  post: postConfig,
  'search-motifs': searchMotifsConfig
};
